import React, { ReactElement } from 'react';
import styles from './Quote.module.css';

type Props = {
  item: {
    bold?: boolean;
    text: string;
  };
  children: [];
};
export default function Quote({ item, children }: Props): ReactElement {
  return (
    <>
      <div className={`quoteblock ${styles.quoteblock}`}>
        <div className={`quoteline ${styles.quoteline}`}></div>
        <div className={`font-jamjuree quotetext ${styles.quotetext}`}>{children}</div>
      </div>
    </>
  );
}
